import { render, staticRenderFns } from "./BulkCreateAccountsContainer.vue?vue&type=template&id=2b245196&"
import script from "./BulkCreateAccountsContainer.vue?vue&type=script&lang=js&"
export * from "./BulkCreateAccountsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports